/********************
 * Search Modal
 * ********************/
$('.xs-search').on('click', function(e) {
    $('body').toggleClass('search-open');
});
$('.close-search').on('click', function(e) {
    $('body').toggleClass('search-open');
});

$('#predictive-search').on('click', '#xclose', function(event) {
    event.preventDefault();
    $('#predictive-search-wrapper').remove();
    $("#predictive-search").css({
        display: 'none'
    });
});

/********************
 * Sticky tools
 * ********************/
$(document).ready(function() {
    $(window).scroll(function() {
        if ($(document).scrollTop() > 50) {
            $("#tools").addClass("sticky-tools");
        } else {
            $("#tools").removeClass("sticky-tools");
        }
    });
});


/********************
 * Sticky Nav
 * ********************/
// When the user scrolls the page, execute myFunction
window.onscroll = function() {
    myFunction()
};

// Get the navbar
var navbar = document.getElementById("navbar");

// Get the offset position of the navbar
var sticky = navbar.offsetTop;

// Add the sticky class to the navbar when you reach its scroll position. Remove "sticky" when you leave the scroll position
function myFunction() {
    if (window.pageYOffset >= sticky) {
        navbar.classList.add("sticky")
    } else {
        navbar.classList.remove("sticky");
    }
}

/********************
 * Quantity 
 * ********************/
$('.add').click(function() {
    if ($(this).prev().val() < 100) {
        $(this).prev().val(+$(this).prev().val() + 1);
    }
});
$('.sub').click(function() {
    if ($(this).next().val() > 1) {
        if ($(this).next().val() > 1) $(this).next().val(+$(this).next().val() - 1);
    }
});

/********************
 * Filter
 * ********************/

$(document).ready(function() {
    // Show hide popover
    $(".dropdown").click(function() {
        $(this).find(".dropdown-menu").slideToggle("fast");
    });
});
$(document).on("click", function(event) {
    var $trigger = $(".dropdown");
    if ($trigger !== event.target && !$trigger.has(event.target).length) {
        $(".dropdown-menu").slideUp("fast");
    }
});


/********************
 * Carousels
 * ********************/
jQuery("#image-slider").owlCarousel({
    nav: true, // Show next and prev buttons
    dots: true, // Remove dots

    slideSpeed: 6000,
    paginationSpeed: 400,

    items: 1,
    itemsDesktop: false,
    itemsDesktopSmall: false,
    itemsTablet: false,
    itemsMobile: false,

    loop: true,
    autoplay: true,
    autoplayTimeout: 6000,
    autoplayHoverPause: true
});

jQuery("#quote-slider").owlCarousel({
    nav: true, // Show next and prev buttons
    dots: true, // Remove dots

    slideSpeed: 6000,
    paginationSpeed: 400,

    items: 1,
    itemsDesktop: false,
    itemsDesktopSmall: false,
    itemsTablet: false,
    itemsMobile: false,

    loop: true,
    autoplay: true,
    autoplayTimeout: 6000,
    autoplayHoverPause: true
});


jQuery("#collection-feature").owlCarousel({
    nav: true, // Show next and prev buttons
    dots: false, // Remove dots

    slideSpeed: 16000,
    paginationSpeed: 1400,

    responsiveClass: true,
    responsive: {
        // breakpoint from 0 up
        0: {
            items: 1,
            nav: true
        },
        // breakpoint from 500 up
        720: {
            items: 2,
            nav: true
        },
        // breakpoint from 800 up
        1120: {
            items: 3,
            nav: false
        }
    },

    loop: true,
    autoplay: true,
    autoplayTimeout: 6000,
    autoplayHoverPause: true
});

jQuery("#product-gallery--navigation").owlCarousel({
    nav: true, // Show next and prev buttons
    dots: false, // Remove dots

    slideSpeed: 9999999999000,
    paginationSpeed: 1400,

    responsiveClass: true,
    responsive: {
        // breakpoint from 0 up
        0: {
            items: 3,
            nav: true
        },
        // breakpoint from 1120 up
        1120: {
            items: 4,
            nav: true
        }
    },

    loop: false,
    autoplay: false,
    autoplayTimeout: 6000,
    autoplayHoverPause: true
});




$(document).ready(function() {
    if (url.includes('?filter.p.m.custom.limited_edition=1')) {
        $('.dropdown-menu li.filter-ltd').addClass('active');
        $('.dropdown-menu li.filter-clear').addClass('show');
    }
    if (url.includes('?filter.v.availability=1')) {
        $('.dropdown-menu li.filter-instock').addClass('active');
        $('.dropdown-menu li.filter-clear').addClass('show');
    }
    if (url.includes('?filter.v.price.gte=&filter.v.price.lte=20')) {
        $('.dropdown-menu li.filter-20').addClass('active');
        $('.dropdown-menu li.filter-clear').addClass('show');
    }
    if (url.includes('?filter.v.price.gte=&filter.v.price.lte=50')) {
        $('.dropdown-menu li.filter-50').addClass('active');
        $('.dropdown-menu li.filter-clear').addClass('show');
    }
    if (url.includes('?filter.v.price.gte=&filter.v.price.lte=100')) {
        $('.dropdown-menu li.filter-100').addClass('active');
        $('.dropdown-menu li.filter-clear').addClass('show');
    }
    if (url.includes('?sort_by=price-descending')) {
        $('.dropdown-menu li.sort-des').addClass('active');
        $('.dropdown-menu li.sort-clear').addClass('show');
    }
    if (url.includes('?sort_by=price-ascending')) {
        $('.dropdown-menu li.sort-asc').addClass('active');
        $('.dropdown-menu li.sort-clear').addClass('show');
    }
    if (url.includes('?sort_by=created-descending')) {
        $('.dropdown-menu li.sort-cre-des').addClass('active');
        $('.dropdown-menu li.sort-clear').addClass('show');
    }
    if (url.includes('?sort_by=best-selling')) {
        $('.dropdown-menu li.sort-best').addClass('active');
        $('.dropdown-menu li.sort-clear').addClass('show');
    }



    if (url.includes('&filter.p.m.custom.limited_edition=1')) {
        $('.dropdown-menu li.filter-ltd').addClass('active');
        $('.dropdown-menu li.filter-clear').addClass('show');
    }
    if (url.includes('&filter.v.availability=1')) {
        $('.dropdown-menu li.filter-instock').addClass('active');
        $('.dropdown-menu li.filter-clear').addClass('show');
    }
    if (url.includes('&filter.v.price.gte=&filter.v.price.lte=20')) {
        $('.dropdown-menu li.filter-20').addClass('active');
        $('.dropdown-menu li.filter-clear').addClass('show');
    }
    if (url.includes('&filter.v.price.gte=&filter.v.price.lte=50')) {
        $('.dropdown-menu li.filter-50').addClass('active');
        $('.dropdown-menu li.filter-clear').addClass('show');
    }
    if (url.includes('&filter.v.price.gte=&filter.v.price.lte=100')) {
        $('.dropdown-menu li.filter-100').addClass('active');
        $('.dropdown-menu li.filter-clear').addClass('show');
    }
    if (url.includes('&sort_by=price-descending')) {
        $('.dropdown-menu li.sort-des').addClass('active');
        $('.dropdown-menu li.sort-clear').addClass('show');
    }
    if (url.includes('&sort_by=price-ascending')) {
        $('.dropdown-menu li.sort-asc').addClass('active');
        $('.dropdown-menu li.sort-clear').addClass('show');
    }
    if (url.includes('&sort_by=created-descending')) {
        $('.dropdown-menu li.sort-cre-des').addClass('active');
        $('.dropdown-menu li.sort-clear').addClass('show');
    }
    if (url.includes('&sort_by=best-selling')) {
        $('.dropdown-menu li.sort-best').addClass('active');
        $('.dropdown-menu li.sort-clear').addClass('show');
    }
});